import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Nillable } from '@web/utils';
import { WarehouseFileRequest } from './warehouse-file.request';
import { WarehouseReleaseProductRequest } from './warehouse-release-product.request';
import { dateWithOffsetSerializer } from '@web/common';

@jsonObject
export class WarehouseReleaseUpdateRequest {
  @jsonMember(Date, { serializer: dateWithOffsetSerializer() })
  public readonly releasedAt!: Date;

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  @jsonArrayMember(WarehouseReleaseProductRequest)
  public readonly goods: WarehouseReleaseProductRequest[];

  @jsonArrayMember(WarehouseFileRequest)
  public readonly files?: Nillable<WarehouseFileRequest[]>;

  public constructor(data: {
    releasedAt: Date;
    comment?: Nillable<string>;
    products: WarehouseReleaseProductRequest[];
    files?: Nillable<WarehouseFileRequest[]>;
  }) {
    this.releasedAt = data.releasedAt;
    this.comment = data.comment;
    this.goods = data.products;
    this.files = data.files;
  }
}
